import { ActivityFeedTile } from "../ActivityFeedTile.js";

export function ActivityFeedWidget() {
  return <ActivityFeedTile />;
}
